<template>
  <div class="retrospect-record">
    <!-- 搜索区域 -->
    <div class="search-box">
      <div class="input-item">
        <label class="label">回溯年份</label>
        <DatePicker transfer v-model="searchParams.year" type="year" placement="bottom-start" placeholder="选择年份"></DatePicker>
      </div>
      <div class="input-item">
        <label class="label">IFA名称</label>
        <Select v-model="searchParams.name" clearable filterable>
          <Option v-for="item in userList" :value="item.name" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <label class="label">回溯状态</label>
        <Select v-model="searchParams.backStatus" clearable placeholder="请选择">
          <Option :value="1">回溯成功</Option>
          <Option :value="0">回溯失败</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
      </div>
    </div>
    <!-- 数据表格 -->
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" border>
        <template slot-scope="{ row }" slot="name"> {{ row.englishName ? row.englishName + '/' : '' }}{{ row.name }} </template>
        <template slot-scope="{ row }" slot="backStatus">
          <Tag :color="getStatusColor(row.backStatus)">
            {{ getStatusText(row.backStatus) }}
          </Tag>
        </template>
        <template slot-scope="{ row }" slot="unMetQuarter">
          {{ row.unMetQuarter | quarterFormat }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn primary" @click="handleDetail(row)">详情</span>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>

    <!-- 详情弹窗 -->
    <retrospectDetailModal ref="retrospectDetailModal"></retrospectDetailModal>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { pageTool, common } from '@/api/mixins';
import retrospectDetailModal from './retrospectDetailModal.vue';

export default {
  name: 'RetrospectRecord',
  components: {
    retrospectDetailModal
  },
  mixins: [pageTool, common],
  props: {
    userList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showAlert: true,
      listLoading: false,
      tableData: [],
      total: 0,
      searchParams: {
        pageNo: 1,
        pageSize: 10,
        year: '',
        name: '',
        retrospectStatus: ''
      },
      yearOptions: [],
      columns: [
        {
          title: '序号',
          align: 'center',
          type: 'index',
          width: 80
        },
        {
          title: '回溯自然年',
          key: 'year',
          align: 'center',
          minWidth: 110
        },
        {
          title: 'IFA姓名',
          slot: 'name',
          align: 'center',
          minWidth: 140
        },
        {
          title: '所属团队',
          key: 'groupName',
          align: 'center',
          minWidth: 140,
          render: (h, params) => {
            return h('span', {}, params.row.groupName || '-');
          }
        },
        {
          title: '入职时间',
          key: 'entryTime',
          align: 'center',
          minWidth: 110,
          render: (h, params) => {
            return h('span', {}, params.row.entryTime ? dayjs(params.row.entryTime).format('YYYY-MM-DD') : '-');
          }
        },
        {
          title: '年标保 (美元)',
          key: 'fee',
          align: 'center',
          minWidth: 130
        },
        {
          title: '回溯状态',
          slot: 'backStatus',
          align: 'center',
          minWidth: 120
        },
        {
          title: '未达标季度',
          slot: 'unMetQuarter',
          align: 'center',
          minWidth: 100
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 80
        }
      ]
    };
  },
  mounted() {
    this.initListAjax('/buz/userTraceback/read/list');
  },
  filters: {
    /**
     * 季度格式化
     */
    quarterFormat(quarter) {
      if (!quarter) return '-';
      quarter = quarter.split('、');
      return quarter.map(q => 'Q' + q).join('、');
    }
  },
  methods: {
    setListParams(params) {
      if (params.year) {
        params.year = dayjs(params.year).format('YYYY');
      }
    },
    /**
     * 查看详情
     */
    handleDetail(row) {
      this.$refs.retrospectDetailModal.open(row);
    },

    /**
     * 获取状态颜色
     */
    getStatusColor(status) {
      const map = {
        1: 'success',
        0: 'error'
      };
      return map[status] || 'default';
    },

    /**
     * 获取状态文本
     */
    getStatusText(status) {
      const map = {
        1: '回溯成功',
        0: '回溯失败'
      };
      return map[status] || '-';
    },

    /**
     * 格式化数字
     */
    formatNumber(value) {
      if (value === null || value === undefined) return '0.00';
      return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
};
</script>

<style lang="scss" scoped></style>
